import React from 'react';
import {useSelector} from "react-redux";
import {getRowNumber} from "mindsets-js-sdk";

import Row from './Row';

export default function () {
    const items = useSelector(state => state.action_logs);
    const current = useSelector(state => state.action_logs_current);
    const limit = useSelector(state => state.action_logs_limit);

    return (
        <div className="table-responsive">
            <table className="table table-bordered table-hover">
                <thead>
                <tr className="text-center">
                    <th scope="col">No</th>
                    <th scope="col">ID</th>
                    <th scope="col">Actor</th>
                    <th scope="col">Action</th>
                    <th scope="col">Challenge</th>
                    <th scope="col">Lesson</th>
                    <th scope="col">Stream</th>
                    <th scope="col">Stream Index</th>
                    <th scope="col">Timestamp</th>
                </tr>
                </thead>
                <tbody>
                {items.map((item, index) => {
                    return (
                        <Row
                            key={item.id}
                            item={item}
                            row_number={getRowNumber(index, current, limit)}
                        />
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};
